import React from 'react';

function clientRandomizer(props) {
  const millsAds = [
    {
      image: '/romeo-juliet-2022/sponsors/eccles.jpg',
      link: 'https://www.gsecclesfoundation.org/',
      alt: 'Eccles Foundation',
      class: 'webFormat',
    },
    {
      image: '/romeo-juliet-2022/sponsors/member.jpg',
      link: 'https://balletwest.org/support/join-the-club/become-a-member',
      alt: 'Become a Ballet West Member',
      class: 'webFormat',
    },
  ];

  const randomAd = millsAds[Math.floor(Math.random() * millsAds.length)];

  return (
    <>
      <hr />
      <br />
      <a href={randomAd.link} target="_blank" rel="noopener noreferrer">
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </a>
      <br />
      <br />
      <hr />
    </>
  );
}

export default clientRandomizer;
